// src/pages/OffersPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { productService } from '../services/productService';
import ProductCard from '../components/Products/ProductCard';

const OffersPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { addToCart } = useCart();
  
  // Header nundi pass ayina mode techukuntunnam (Default ga QUICK)
  const queryParams = new URLSearchParams(location.search);
  const deliveryType = (queryParams.get('mode') || 'QUICK').toUpperCase();

  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOffersData = async () => {
      setLoading(true);
      try {
        const data = await productService.getOffers(deliveryType);
        setOffers(data || []);
      } catch (error) {
        console.error("Error loading offers:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchOffersData();
  }, [deliveryType]);

  return (
    <div className="py-6 px-4 md:px-8 max-w-7xl mx-auto w-full min-h-[70vh]">
      
      {/* Header Section (Removed internal toggles) */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8 border-b border-gray-100 pb-5">
        <div className="flex items-center gap-3">
          <button 
            onClick={() => navigate(-1)} 
            className="w-10 h-10 rounded-full bg-white shadow-sm border border-gray-200 hover:bg-gray-50 flex items-center justify-center text-gray-600 transition-colors"
          >
            <i className="fas fa-arrow-left"></i>
          </button>
          <div>
            <h1 className="text-2xl md:text-3xl font-black text-gray-900 tracking-tight flex items-center gap-2">
              <i className="fas fa-tags text-[#FF7A59]"></i> Special Offers
            </h1>
            <p className="text-sm text-gray-500 font-medium mt-1">
              Grab the best deals for <span className="font-black text-[#0F2F63]">{deliveryType}</span> delivery before they run out!
            </p>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      {loading ? (
        <div className="flex flex-col items-center justify-center py-32 bg-white rounded-2xl border border-gray-100 shadow-sm">
          <i className="fas fa-spinner fa-spin text-4xl text-[#0078ad] mb-4"></i>
          <p className="text-gray-500 font-bold tracking-widest uppercase text-sm">Fetching Top Deals...</p>
        </div>
      ) : offers.length === 0 ? (
        <div className="text-center py-24 bg-white rounded-3xl border border-gray-100 shadow-sm">
          <div className="w-24 h-24 bg-orange-50 text-orange-400 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner">
            <i className="fas fa-gift text-4xl"></i>
          </div>
          <h3 className="text-2xl text-gray-800 font-black mb-2">No Active Offers</h3>
          <p className="text-sm text-gray-500 max-w-md mx-auto">
            There are currently no active offers for {deliveryType.toLowerCase()} delivery. Please check back later or switch delivery mode.
          </p>
          <button 
            onClick={() => navigate(`/${deliveryType.toLowerCase()}`)}
            className="mt-8 bg-[#0F2F63] text-white px-8 py-3 rounded-xl font-bold hover:bg-[#1a4a8a] transition-all shadow-md"
          >
            Back to Home
          </button>
        </div>
      ) : (
        <div className="space-y-12">
          {offers.map((offer) => (
            <div key={offer.offerId} className="w-full bg-white p-5 md:p-8 rounded-3xl shadow-sm border border-gray-100">
              
              {/* Offer Heading Section */}
              <div className="mb-6 flex flex-col md:flex-row md:items-end justify-between border-b border-gray-100 pb-4 gap-4">
                <div>
                  <h2 className="text-xl md:text-2xl font-black text-gray-900 uppercase tracking-wide">
                    {offer.title}
                  </h2>
                  {offer.subtitle && (
                    <p className="text-sm md:text-base font-bold text-orange-500 mt-1 flex items-center gap-1.5">
                      <i className="fas fa-certificate"></i> {offer.subtitle}
                    </p>
                  )}
                </div>
                
                {offer.offerType && (
                  <span className="px-3 py-1 bg-sky-50 text-sky-600 rounded-lg text-xs font-black uppercase tracking-widest border border-sky-100 self-start md:self-auto">
                    {offer.offerType}
                  </span>
                )}
              </div>

              {/* Offer Products Grid */}
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 gap-3 md:gap-5">
                {offer.products && offer.products.length > 0 ? (
                  offer.products.map((prod) => (
                    <ProductCard 
                      key={prod.outletVariantId || prod.variantId || prod.productId} 
                      product={prod} 
                      addToCart={addToCart} 
                    />
                  ))
                ) : (
                  <div className="col-span-full py-8 text-center text-gray-400 font-medium">
                    No products mapped to this offer currently.
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OffersPage;